import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { getKeycloak, withVerifiedToken } from '../auth/keycloak';
import { createGraphQLClient } from '../lib/graphql-client';
import { OVERRIDE_HISTORY_QUERY } from '../lib/queries';
import type { MobilistOverrideEvent } from '../types/vehicle';

export const OVERRIDE_HISTORY_QUERY_KEY = 'mobilist-override-history';

interface OverrideHistoryGraphQLResponse {
  mobilistOverrideHistory: MobilistOverrideEvent[];
}

/**
 * A vehicle's override timeline, newest first.
 *
 * The caller mounts this only while the history modal is open, so browsing a page of results costs
 * nothing — the reason shown on each badge already comes with the search.
 */
export function useVehicleOverrideHistory(vehicleId: string): UseQueryResult<MobilistOverrideEvent[], Error> {
  return useQuery({
    queryKey: [OVERRIDE_HISTORY_QUERY_KEY, vehicleId],
    queryFn: async () => {
      return withVerifiedToken(getKeycloak(), async (verifiedToken) => {
        const data = await createGraphQLClient(verifiedToken).request<OverrideHistoryGraphQLResponse>(
          OVERRIDE_HISTORY_QUERY,
          { input: { vehicleId } }
        );

        return data.mobilistOverrideHistory;
      });
    }
  });
}
